import { UserListCard, UserListCardSkeleton } from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/components'
import { NoResultsCard } from '@apps-common/components/common'
import { motionFadeIn } from '@apps-common/config/motion-variants'
import { IMMSiteModel } from '@apps-common/types/my-monitoring'
import { IMyMonitoringUserModel } from '@apps-common/types/portal/users'
import { motion } from 'framer-motion'

interface IProps {
  loading: boolean
  site?: IMMSiteModel
  data?: IMyMonitoringUserModel[]
  disabled?: boolean
}

export const SiteMyMonitoringUsers: React.FC<IProps> = ({ loading, site, data, disabled }) => {
  loading = loading || !site || !data

  return (
    <div className='grid lg:grid-cols-2 gap-6'>
      {loading && Array.from(Array(4).keys()).map((k) => <UserListCardSkeleton key={`system-user-list-card-skeleton-${k}`} />)}
      {!loading &&
        data?.map((u, i) => (
          <motion.div key={`unit-my-monitoring-user-${u.id}-${i}`} {...motionFadeIn(0.25)}>
            <UserListCard
              index={i}
              type='myMonitoring'
              unitId={site?.unitId!}
              ipAddress={site?.ipAddress!}
              userId={u.id}
              profileImage={u.profileImage}
              name={`${u.firstName} ${u.lastName}`}
              email={u.email}
              zone={u.userNumber}
              partition={u.userPartition}
              disabled={disabled}
              isAdmin={u.isAdmin}
            />
          </motion.div>
        ))}
      {!loading && data?.length === 0 && <NoResultsCard>This site has no myMonitoring users.</NoResultsCard>}
    </div>
  )
}
